export default {
    bind(el, binding) {
        $(el).tooltip(binding.value);
    },
    unbind(el) {
        $(el).tooltip('dispose');
    },
};
